<template>
  <div class="quotationSupplierCreate">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="SQId">{{ $t.onlineOrder.editTitle4 }}</div>
      <div class="title" v-else>{{ $t.onlineOrder.editTitle4 }}</div>

      <van-field
        v-model="form.customer.text"
        :label="$t.onlineOrder.supplierName"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
        @click="onShowEmit(0, 'showQuotationSupplierCreateCustomer')"
        clickable
        readonly
        required
        :rules="formRule"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy($event, form.customer.text)"
            native-type="button"
            v-if="form.customer.value"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        clickable
        readonly
        :value="form.regionName"
        :label="$t.onlineOrder.area"
        :placeholder="$t.meta.select"
        @click="onShowEmit(0, 'showQuotationSupplierCreateArea')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.countryName"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit(0, 'showQuotationSupplierCreateCountry')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.cityName"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit(0, 'showQuotationSupplierCreateCity')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.bcName"
        :label="$t.onlineOrder.bcType"
        :placeholder="$t.meta.select"
        @click="onShowEmit(0, 'showQuotationSupplierCreateBc')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.awName"
        :label="$t.onlineOrder.awWay"
        :placeholder="$t.meta.select"
        @click="onShowEmit(0, 'showQuotationSupplierCreateAw')"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.operationNotes"
        :label="$t.onlineOrder.notes"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="2"
      />

      <div class="title">{{ $t.onlineOrder.divider1 }}</div>

      <div class="multi-table" v-if="form.chargedItemList">
        <van-field name="stepper" :label="$t.onlineOrder.chargeItems">
          <template #input>
            <van-stepper
              :min="1"
              :value="form.chargedItemList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.chargedItemList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.LeavelName"
            :label="$t.onlineOrder.section"
            @click="pickerShow(index, 'showLevelPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.ItemName"
            :label="$t.onlineOrder.billName"
            @click="onShowEmit(index, 'showQuotationSupplierCreateItem')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.UnitName"
            :label="$t.onlineOrder.chargingUnit"
            @click="pickerShow(index, 'showUnitPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.MinChargingPrice"
            :label="$t.onlineOrder.minChargingPrice"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.UnitPrice"
            :label="$t.onlineOrder.unitPrice"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.IsMandatoryItemStr"
            :label="$t.onlineOrder.isMandatoryItem"
            @click="pickerShow(index, 'showIsMandatoryItemPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <span v-if="calculated">
            <van-field
              v-model="item.CostPrice"
              :label="$t.onlineOrder.costPrice"
              disabled
            />
            <van-field
              v-model="item.ProfitPrice"
              :label="$t.onlineOrder.profitPrice"
              @change="getSalesPrice(index, item.IsMandatoryItem)"
              :placeholder="$t.meta.input"
              oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            />
            <van-field
              v-model="item.SalesPrice"
              :label="$t.onlineOrder.salesPrice"
              disabled
            />
          </span>
        </div>
        <div class="multi-table-footer" v-if="calculationDetailsList.length > 0">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            native-type="button"
            @click="showCalculate"
            >{{ $t.onlineOrder.calculateDetail }}</van-button
          >
        </div>
      </div>

      <div class="title">{{ $t.onlineOrder.divider2 }}</div>

      <van-field
        v-model="form.weight"
        :label="$t.onlineOrder.totalWeight + ' (kg)'"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.volume"
        :label="$t.onlineOrder.volume + ' (cbm)'"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.storageOverdueDays"
        :label="$t.onlineOrder.storageOverdueDays"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.shipmentCount"
        :label="$t.onlineOrder.shipmentCount"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.billCount"
        :label="$t.onlineOrder.billCount"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.conatiner20"
        :label="$t.onlineOrder.conatiner20"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.conatiner40"
        :label="$t.onlineOrder.conatiner40"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.conatiner40HQ"
        :label="$t.onlineOrder.conatiner40HQ"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.cifGoodsValue"
        :label="$t.onlineOrder.cifGoodsValue"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.piecesNumber"
        :label="$t.onlineOrder.piecesNumber"
        :placeholder="$t.meta.input"
      />

      <div class="title">{{ $t.onlineOrder.divider3 }}</div>

      <van-field
        v-model="form.currency"
        :label="$t.onlineOrder.chargingCurrency"
        @click="onShowEmit(0, 'showQuotationSupplierCreateCurrency')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <span v-for="(item, index) in currencyList" :key="index">
        <van-field
          v-model="item.value"
          :label="item.text + ' / ' + $t.onlineOrder.oCurrency"
          :placeholder="$t.meta.input"
          v-if="index != 0"
        />
      </span>

      <van-field
        :value="currency.text"
        :label="$t.onlineOrder.dCurrnecy"
        @click="onShowEmit(0, 'showQuotationSupplierCreateDisplayCurrency')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        v-if="currency"
      />

      <div class="title">{{ $t.onlineOrder.divider4 }}</div>

      <van-cell-group>
        <van-cell class="customCheckBox" :title="$t.onlineOrder.isCustomsInspection">
          <template #right-icon>
            <van-checkbox v-model="form.isCustomsInspection" />
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group>
        <van-cell
          class="customCheckBox"
          :title="$t.onlineOrder.isChargeUponDelivery"
          :label="'+' + chargeUponDeliveryTotalPrice"
        >
          <template #right-icon>
            <van-checkbox v-model="form.isChargeUponDelivery" @change="handleCalculate" />
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group>
        <van-cell
          class="customCheckBox"
          :title="$t.onlineOrder.isCostReimbursement"
          :label="'+' + costReimbursementTotalPrice"
        >
          <template #right-icon>
            <van-checkbox v-model="form.isCostReimbursement" @change="handleCalculate" />
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group v-if="form.currency">
        <div class="title">{{ form.currency }}</div>
        <van-cell :title="$t.onlineOrder.totalCost" :value="form.totalCostPrice" />
        <van-cell
          :title="$t.onlineOrder.totalProfitPrice"
          :value="form.totalProfitPrice"
        />
        <van-cell :title="$t.onlineOrder.totalSalesPrice" :value="form.totalSalesPrice" />
      </van-cell-group>

      <van-cell-group v-if="currency">
        <div class="title">{{ currency.text }}</div>
        <van-cell :title="$t.onlineOrder.totalCost" :value="totalCostPrice" />
        <van-cell :title="$t.onlineOrder.totalProfitPrice" :value="totalProfitPrice" />
        <van-cell :title="$t.onlineOrder.totalSalesPrice" :value="totalSalesPrice" />
      </van-cell-group>

      <div class="title">{{ $t.onlineOrder.divider5 }}</div>

      <van-field
        v-model="form.communicationExplanation"
        :label="$t.onlineOrder.communicationExplanation"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="2"
      />

      <van-field :label="$t.onlineOrder.voucherFiles">
        <template #input>
          <van-button
            @click="dialogVoucherShow"
            type="info"
            size="small"
            native-type="button"
            >{{ $t.meta.editButton }}</van-button
          >
        </template>
      </van-field>

      <span v-if="SQId">
        <div class="title">{{ $t.onlineOrder.divider6 }}</div>

        <van-field :label="$t.onlineOrder.recordTitle">
          <template #input>
            <van-button
              @click="dialogRecordVisible = true"
              type="info"
              size="small"
              native-type="button"
              >{{ $t.onlineOrder.viewRecord }}</van-button
            >
          </template>
        </van-field>
      </span>

      <div style="margin: 30px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <div class="tool-bar">
      <van-button type="info" block @click="handleNext">{{
        $t.onlineOrder.calculatePrice
      }}</van-button>
    </div>

    <fetch-list
      event="showQuotationSupplierCreateCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <option-list
      event="showQuotationSupplierCreateArea"
      :options="areaList"
      @onSelect="onSelectArea"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateAw"
      :options="awList"
      @onSelect="onSelectAw"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateBc"
      :options="serviceList"
      @onSelect="onSelectBc"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateCurrency"
      :options="form.currencyExchangeRateList"
      @onSelect="onSelectCurrency"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateDisplayCurrency"
      :options="currencyList"
      @onSelect="onSelectDisplayCurrency"
    ></option-list>

    <option-list
      event="showQuotationSupplierCreateItem"
      :options="billList"
      @onSelect="onSelectItem"
    ></option-list>

    <van-popup v-model="showLevelPicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.section"
        show-toolbar
        :columns="leavelList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'LeavelName', 'LeavelId')"
        @cancel="showLevelPicker = false"
      />
    </van-popup>

    <van-popup v-model="showUnitPicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.chargingUnit"
        show-toolbar
        :columns="unitList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'UnitName', 'QSUId')"
        @cancel="showUnitPicker = false"
      />
    </van-popup>

    <van-popup v-model="showIsMandatoryItemPicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.isMandatoryItem"
        show-toolbar
        :columns="mandatoryList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'IsMandatoryItemStr', 'IsMandatoryItem')"
        @cancel="showIsMandatoryItemPicker = false"
      />
    </van-popup>

    <van-dialog
      :title="$t.onlineOrder.voucherFiles"
      width="90%"
      v-model="dialogVoucherVisible"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
      className="fileList-dialog"
    >
      <slot name="default">
        <div class="fileList-alert">
          <van-form label-width="120px">
            <div class="fileList-table" v-if="form.voucherList">
              <van-field
                name="stepper"
                :label="$t.onlineOrder.fileList"
                v-if="isVoucherEdit"
              >
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="form.voucherList.length"
                    @minus="handleVoucherDel"
                    @plus="handleVoucherAdd"
                    :disable-input="true"
                  />
                </template>
              </van-field>
              <span v-if="isVoucherEdit">
                <div v-for="(item, index) in form.voucherList" :key="index">
                  <div class="fileList-table-header">
                    <div
                      class="fileList-table-btn"
                      @click="handleVoucherDelByIndex(index)"
                    >
                      <van-icon name="close" />
                    </div>
                  </div>
                  <van-field :label="$t.onlineOrder.file + (index + 1)">
                    <template #input>
                      <van-button
                        @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                        type="primary"
                        size="small"
                        style="vertical-align: top; margin: 10px 30px 10px 0px"
                        v-if="item.VoucherFile"
                        >{{ $t.meta.view }}</van-button
                      >
                      <van-uploader
                        :after-read="afterRead1"
                        @click-upload="uploaderClick(index)"
                      >
                        <van-image
                          :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                          width="50"
                          height="50"
                          fit="contain"
                          style="vertical-align: top"
                          v-if="item.VoucherFile"
                        ></van-image>
                        <van-button
                          type="info"
                          size="small"
                          style="vertical-align: top; margin: 10px 30px 10px 0px"
                          v-else
                          >{{ $t.meta.upload }}</van-button
                        >
                      </van-uploader>
                    </template>
                  </van-field>
                </div>
              </span>
              <span v-else>
                <div v-for="(item, index) in voucherList" :key="index">
                  <van-field :label="$t.onlineOrder.file + (index + 1)">
                    <template #input>
                      <van-button
                        @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                        type="primary"
                        size="small"
                        style="vertical-align: top; margin: 10px 30px 10px 0px"
                        v-if="item.VoucherFile"
                        >{{ $t.meta.view }}</van-button
                      >
                      <van-image
                        :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                        width="50"
                        height="50"
                        fit="contain"
                        style="vertical-align: top"
                        v-if="item.VoucherFile"
                      ></van-image>
                    </template>
                  </van-field>
                </div>
              </span>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.onlineOrder.communicationTitle"
      width="90%"
      v-model="dialogRecordVisible"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="false"
      className="fileList-dialog"
    >
      <slot name="default">
        <div class="fileList-alert">
          <van-list class="fileList-list">
            <div
              class="fileList-container"
              v-for="(item, index) in communicationRecordList"
              :key="index"
            >
              <div class="fileList-list-item">
                {{ $t.onlineOrder.recordUserName }}：{{ item.UserName }}
              </div>
              <div class="fileList-list-item">
                {{ $t.onlineOrder.recordCreateTime }}：{{ item.CreateTime }}
              </div>
              <div class="fileList-list-item" v-if="item.CommunicationExplanation">
                {{ $t.onlineOrder.communicationExplanation }}：{{
                  item.CommunicationExplanation
                }}
              </div>
              <div class="fileList-buttons" v-if="item.VoucherCount > 0">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="dialogRecordShow(item.VoucherList)"
                  >{{ $t.onlineOrder.viewFile }}</van-button
                >
              </div>
            </div>
          </van-list>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
  List,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(List);

export default {
  name: "quotationSupplierCreate",
  components: {
    FetchList,
    OptionList,
  },
  data() {
    return {
      SQId: "",
      form: {
        customer: { text: "", value: null },
        regionId: null,
        regionName: "",
        countryId: null,
        countryName: "",
        cityId: null,
        cityName: "",
        bcId: null,
        bcName: "",
        awId: null,
        awName: "",
        isCustomsInspection: null,
        isChargeUponDelivery: null,
        isCostReimbursement: null,
        operationNotes: "",
        communicationExplanation: "",
        chargedItemList: [
          {
            LeavelId: null,
            LeavelName: "",
            BillId: null,
            ItemName: "",
            QSUId: null,
            UnitName: "",
            MinChargingPrice: null,
            UnitPrice: null,
            IsMandatoryItem: 1,
            IsMandatoryItemStr: "",
            CostPrice: null,
            ProfitPrice: null,
            SalesPrice: null,
          },
        ],
        billingItem: {},
        currency: "",
        currencyExchangeRateList: [],
        voucherList: [],
        weight: null, //1
        volume: null, //2
        storageOverdueDays: null, //3
        shipmentCount: null, //4
        billCount: null, //5
        conatiner20: null, //6
        conatiner40: null, //7
        conatiner40HQ: null, //8
        cifGoodsValue: null, //9
        piecesNumber: null, //10
        totalCostPrice: 0, //总成本价格
        totalProfitPrice: 0, //总利润价格
        totalSalesPrice: 0, //总销售价格
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //货币
      currency: {},
      currencyList: [],
      //选项
      settings: [],
      awList: [],
      serviceList: [],
      areaList: [],
      countryList: [],
      cityList: [],
      //items
      leavelList: [],
      billList: [],
      unitList: [],
      voucherList: [],
      mandatoryList: [
        {
          text: this.$t.onlineOrder.mandatory1,
          value: 1,
        },
        {
          text: this.$t.onlineOrder.mandatory2,
          value: 2,
        },
        {
          text: this.$t.onlineOrder.mandatory3,
          value: 3,
        },
      ],
      //picker
      itemIndex: 0,
      showCurrencyPicker: false,
      showLevelPicker: false,
      showUnitPicker: false,
      showIsMandatoryItemPicker: false,
      //文件
      dialogVoucherVisible: false,
      isVoucherEdit: false,
      filesIndex: 0,
      dialogRecordVisible: false,
      communicationRecordList: [],
      //初始化数据
      content: null,
      detailContent: null,
      //显示用
      calculated: false, //已经计算
      chargeUponDeliveryTotalPrice: 0, //是否包含发时收取
      costReimbursementTotalPrice: 0, //是否包含按单实报实销
      calculationDetailsList: [], //计算明细
      totalCostPrice: 0, //总成本价格
      totalProfitPrice: 0, //总利润价格
      totalSalesPrice: 0, //总销售价格
    };
  },
  created() {
    const { SQId } = this.$route.query;
    this.SQId = SQId;
    this.getOptions().then((success) => {
      if (success) {
        if (this.SQId) this.getSupplierQuotationBySQId();
      }
    });
  },
  methods: {
    dialogVoucherShow() {
      this.isVoucherEdit = true;
      this.dialogVoucherVisible = true;
    },
    dialogRecordShow(voucherList) {
      var files = [];
      for (var url of voucherList) {
        files.push({
          VoucherFile: url,
        });
      }
      this.voucherList = files;
      this.isVoucherEdit = false;
      this.dialogVoucherVisible = true;
    },
    handleAdd() {
      this.form.chargedItemList.push({
        LeavelId: null,
        LeavelName: "",
        BillId: null,
        ItemName: "",
        QSUId: null,
        UnitName: "",
        MinChargingPrice: null,
        UnitPrice: null,
        IsMandatoryItem: 1,
        IsMandatoryItemStr: "",
        CostPrice: null,
        ProfitPrice: null,
        SalesPrice: null,
      });
    },
    handleDel() {
      this.form.chargedItemList.pop();
    },
    handleDelByIndex(index) {
      if (this.form.chargedItemList.length > 0) {
        this.form.chargedItemList.splice(index, 1);
      }
    },
    handleVoucherDelByIndex(index) {
      if (this.form.voucherList.length > 0) {
        this.form.voucherList.splice(index, 1);
      }
    },
    handleVoucherDel() {
      if (this.form.voucherList.length > 0) {
        this.form.voucherList.pop();
      }
    },
    handleVoucherAdd() {
      this.form.voucherList.push({
        VoucherFile: "",
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getSupplierQuotationBySQId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          SQId: this.SQId,
        };
        this.$api.onlineOrderManagement
          .getSupplierQuotationBySQId(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.detailContent = data;
      this.calculated = true;
      this.getCities(data.CountryId, false);
      this.form.customer = {
        text: data.CompanyName,
        value: data.CustomerId,
      };
      this.form.regionId = data.RegionId;
      var region = this.areaList.find((c) => c.value == data.RegionId);
      if (region) {
        this.form.regionName = region.text;
      }
      this.form.countryId = data.CountryId;
      var country = this.countryList.find((c) => c.value == data.CountryId);
      if (country) {
        this.form.countryName = country.text;
      }
      this.form.cityId = data.CityId;
      var city = this.cityList.find((c) => c.value == data.CityId);
      if (city) {
        this.form.cityName = city.text;
      }
      this.form.bcId = data.BCId;
      var bc = this.serviceList.find((c) => c.value == data.BCId);
      if (bc) {
        this.form.bcName = bc.text;
      }
      this.form.awId = data.AWId;
      var aw = this.awList.find((c) => c.value == data.AWId);
      if (aw) {
        this.form.awName = aw.text;
      }
      this.form.chargedItemList = data.ChargedItemList;
      for (const changedItem of this.form.chargedItemList) {
        var leavel = this.leavelList.find((c) => c.value == changedItem.LeavelId);
        if (leavel) {
          changedItem.LeavelName = leavel.text;
        }
        var bill = this.billList.find((c) => c.value == changedItem.BillId);
        if (bill) {
          changedItem.ItemName = bill.text;
        }
        var unit = this.unitList.find((c) => c.value == changedItem.QSUId);
        if (unit) {
          changedItem.UnitName = unit.text;
        }
        var mandatory = this.mandatoryList.find(
          (c) => c.value == changedItem.IsMandatoryItem
        );
        if (mandatory) {
          changedItem.IsMandatoryItemStr = mandatory.text;
        }
      }
      this.form.isCustomsInspection = data.IsCustomsInspection == 1 ? true : false;
      this.form.isChargeUponDelivery = data.IsChargeUponDelivery == 1 ? true : false;
      this.form.isCostReimbursement = data.IsCostReimbursement == 1 ? true : false;
      this.form.operationNotes = data.OperationNotes;
      this.communicationRecordList = data.CommunicationRecordList;
      this.calculationDetailsList = data.CalculationDetailsList;
      this.form.currency = data.Currency;
      if (data.CurrencyExchangeRateList.length > 0) {
        this.onSetCurrency(data.CurrencyExchangeRateList);
      }
      //total1
      this.form.weight = data.Weight;
      this.form.volume = data.Volume;
      this.form.storageOverdueDays = data.StorageOverdueDays;
      this.form.shipmentCount = data.ShipmentCount;
      this.form.billCount = data.BillCount;
      this.form.conatiner20 = data.Conatiner20;
      this.form.conatiner40 = data.Conatiner40;
      this.form.conatiner40HQ = data.Conatiner40HQ;
      this.form.cifGoodsValue = data.CifGoodsValue;
      this.form.piecesNumber = data.PiecesNumber;
      //total2
      this.form.totalCostPrice = data.TotalCostPrice;
      this.form.totalProfitPrice = data.TotalProfitPrice;
      this.form.totalSalesPrice = data.TotalSalesPrice;
      //checkbox
      this.chargeUponDeliveryTotalPrice = data.ChargeUponDeliveryTotalPrice;
      this.costReimbursementTotalPrice = data.CostReimbursementTotalPrice;
      this.handleCalculate();
    },
    handleCalculate() {
      this.calculateTotalCost();
      this.calculateProfitAndSales();
    },
    handleNext() {
      this.calculateSupplierQuotationCostPrice().then((success) => {
        if (success) {
          this.calculateTotalCost();
          this.calculateProfitAndSales();
        }
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getOverseasAgentServiceSetting(),
          this.getTakeDeliveryCountryCityList(),
          this.getQuotationServiceBillingUnitList(),
          this.getBillPaymentList(),
          this.getCurrencyList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getOverseasAgentServiceSetting() {
      return new Promise((resolve) => {
        this.$api.supplier
          .getOverseasAgentServiceSetting()
          .then((res) => {
            this.settings = res.data;

            var awList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.AWName,
                value: item.AWId,
              };
              awList.push(data);
            });
            this.awList = this.$commonMethod.deepClone(awList);

            var serviceList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.BCName,
                value: item.BCId,
              };
              serviceList.push(data);
            });
            this.serviceList = this.$commonMethod.deepClone(serviceList);

            var leavelList = [];
            this.settings[2].forEach((item) => {
              let data = {
                text: item.LeavelName,
                value: item.LeavelId,
              };
              leavelList.push(data);
            });
            this.leavelList = this.$commonMethod.deepClone(leavelList);

            var areaList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.RegionName,
                value: item.RegionId,
              };
              areaList.push(data);
            });
            this.areaList = this.$commonMethod.deepClone(areaList);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getTakeDeliveryCountryCityList() {
      return new Promise((resolve) => {
        var param = {
          BusinessType: 5,
        };
        this.$api.myCustomer
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              var cityList = [];
              if (item.CityList) {
                for (var city of item.CityList) {
                  cityList.push({
                    text: city.City_cn + "," + city.City_en,
                    value: city.CityId,
                  });
                }
              }
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
                cityList: cityList,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCities(countryId, isReset) {
      for (let country of this.countryList) {
        if (country.value == countryId) {
          this.cityList = country.cityList;
          if (isReset) {
            this.form.cityId = null;
            this.form.cityName = "";
          }
        }
      }
    },
    getQuotationServiceBillingUnitList() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getQuotationServiceBillingUnitList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.QSUId,
              };
              result.push(data);
            });
            this.unitList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getBillPaymentList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getBillPaymentListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.BillId,
              };
              result.push(data);
            });
            this.billList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.Code,
                value: item.Code,
                rightText: item.Note,
              };
              result.push(data);
            });
            this.form.currencyExchangeRateList = result;

            this.currencyList = [
              {
                text: this.$t.onlineOrder.oCurrency,
                value: 1,
              },
              {
                text: "USD",
                value: null,
              },
              {
                text: "CNY",
                value: null,
              },
            ];
            this.currency = this.$commonMethod.deepClone(this.currencyList[0]);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSetCurrency(data) {
      var currencyList = [];
      for (var item of data) {
        currencyList.push({
          Currency: item.Currency,
          ExchangeRate: item.ExchangeRate,
        });
      }

      var usd = currencyList.find((p) => p.Currency == "USD");
      var cny = currencyList.find((p) => p.Currency == "CNY");
      this.currencyList = [
        {
          text: this.$t.onlineOrder.oCurrency,
          value: 1,
        },
        {
          text: "USD",
          value: usd ? usd.ExchangeRate : null,
        },
        {
          text: "CNY",
          value: cny ? cny.ExchangeRate : null,
        },
      ];
      this.currency = this.$commonMethod.deepClone(this.currencyList[0]);
    },
    pickerShow(index, pickerName) {
      this[pickerName] = true;
      this.itemIndex = index;
    },
    onSelectCustomer(e) {
      this.form.customer.text = e.text;
      this.form.customer.value = e.value;
      this.$forceUpdate();
    },
    onSelectArea(e) {
      this.form.regionName = e.text;
      this.form.regionId = e.value;
      this.$forceUpdate();
    },
    onSelectCountry(e) {
      this.form.countryName = e.text;
      this.form.countryId = e.value;
      this.getCities(e.value, true);
      this.$forceUpdate();
    },
    onSelectCity(e) {
      this.form.cityName = e.text;
      this.form.cityId = e.value;
      this.$forceUpdate();
    },
    onSelectAw(e) {
      this.form.awName = e.text;
      this.form.awId = e.value;
      this.$forceUpdate();
    },
    onSelectBc(e) {
      this.form.bcName = e.text;
      this.form.bcId = e.value;
      this.$forceUpdate();
    },
    onSelectCurrency(e) {
      this.form.currency = e.text;
      this.$forceUpdate();
    },
    onSelectDisplayCurrency(e) {
      this.currency.text = e.text;
      this.currency.value = e.value;
      this.handleCalculate();
      this.$forceUpdate();
    },
    onSelectItem(e) {
      this.form.chargedItemList[this.itemIndex].ItemName = e.text;
      this.form.chargedItemList[this.itemIndex].BillId = e.value;
      this.$forceUpdate();
    },
    pickerConfirm(e, text, value) {
      this.form.chargedItemList[this.itemIndex][text] = e.text;
      this.form.chargedItemList[this.itemIndex][value] = e.value;
      this.showCurrencyPicker = false;
      this.showLevelPicker = false;
      this.showUnitPicker = false;
      this.showIsMandatoryItemPicker = false;
    },
    onShowEmit(index, emit) {
      this.itemIndex = index;
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      var currencyList = [];
      for (var index in this.currencyList) {
        if (index > 0) {
          currencyList.push({
            Currency: this.currencyList[index].text,
            ExchangeRate: this.currencyList[index].value,
          });
        }
      }
      var param = {
        CustomerId: this.form.customer.value,
        RegionId: this.form.regionId,
        CountryId: this.form.countryId,
        CityId: this.form.cityId,
        BCId: this.form.bcId,
        AWId: this.form.awId,
        Weight: this.form.weight,
        Volume: this.form.volume,
        ShipmentCount: this.form.shipmentCount,
        BillCount: this.form.billCount,
        StorageOverdueDays: this.form.storageOverdueDays,
        Conatiner20: this.form.conatiner20,
        Conatiner40: this.form.conatiner40,
        Conatiner40HQ: this.form.conatiner40HQ,
        CifGoodsValue: this.form.cifGoodsValue,
        PiecesNumber: this.form.piecesNumber,
        IsCustomsInspection: this.form.isCustomsInspection ? 1 : 0,
        IsChargeUponDelivery: this.form.isChargeUponDelivery ? 1 : 0,
        IsCostReimbursement: this.form.isCostReimbursement ? 1 : 0,
        TotalCostPrice: this.form.totalCostPrice,
        TotalProfitPrice: this.form.totalProfitPrice,
        TotalSalesPrice: this.form.totalSalesPrice,
        OperationNotes: this.form.operationNotes,
        CommunicationExplanation: this.form.communicationExplanation,
        ChargedItemList: this.form.chargedItemList,
        Currency: this.form.currency,
        CurrencyExchangeRateList: currencyList,
        VoucherList: this.form.voucherList,
      };
      if (this.SQId) {
        param.SQId = this.SQId;
      }
      this.$commonMethod.showLoading();
      this.$api.onlineOrderManagement
        .addSupplierQuotation(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onCopy(e, text) {
      e.stopPropagation();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    calculateSupplierQuotationCostPrice() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var chargedItemList = [];
        for (var item of this.form.chargedItemList) {
          chargedItemList.push({
            LeavelId: item.LeavelId,
            LeavelName: item.LeavelName,
            BillId: item.BillId,
            ItemName: item.ItemName,
            QSUId: item.QSUId,
            UnitName: item.UnitName,
            MinChargingPrice: item.MinChargingPrice,
            UnitPrice: item.UnitPrice,
            IsMandatoryItem: item.IsMandatoryItem,
          });
        }
        var param = {
          Currency: this.form.currency,
          Weight: this.form.weight,
          Volume: this.form.volume,
          ShipmentCount: this.form.shipmentCount,
          BillCount: this.form.billCount,
          StorageOverdueDays: this.form.storageOverdueDays,
          Conatiner20: this.form.conatiner20,
          Conatiner40: this.form.conatiner40,
          Conatiner40HQ: this.form.conatiner40HQ,
          ChargedItemList: chargedItemList,
        };
        this.$api.onlineOrderManagement
          .calculateSupplierQuotationCostPrice(param)
          .then((res) => {
            this.content = res.data;
            this.calculated = true;
            //勾选框
            this.chargeUponDeliveryTotalPrice = this.content.ChargeUponDeliveryTotalPrice;
            this.costReimbursementTotalPrice = this.content.CostReimbursementTotalPrice;
            //计费明细
            this.calculationDetailsList = this.content.CalculationDetailsList;
            //收费项目
            if (this.content.ChargedItemList.length > 0) {
              for (var index1 in this.content.ChargedItemList) {
                var item1 = this.content.ChargedItemList[index1];
                for (var index2 in this.form.chargedItemList) {
                  var item2 = this.form.chargedItemList[index2];
                  if (index1 == index2) {
                    item2.CostPrice = item1.CostPrice;
                    item2.ProfitPrice = item1.ProfitPrice;
                    item2.SalesPrice = item1.SalesPrice;
                  }
                }
              }
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getSalesPrice(index, type) {
      var chargedItem = this.form.chargedItemList[index];
      if (chargedItem.ProfitPrice) {
        chargedItem.SalesPrice =
          parseFloat(chargedItem.CostPrice) + parseFloat(chargedItem.ProfitPrice);
      } else {
        chargedItem.SalesPrice = null;
      }
      this.calculateProfitAndSales();
    },
    calculateTotalCost() {
      if (this.detailContent) {
        var totalCostPrice = this.detailContent.TotalCostPrice;
        if (this.form.isChargeUponDelivery || this.form.isCostReimbursement) {
          if (this.form.isChargeUponDelivery) {
            totalCostPrice = totalCostPrice + this.chargeUponDeliveryTotalPrice;
          }
          if (this.form.isCostReimbursement) {
            totalCostPrice = totalCostPrice + this.costReimbursementTotalPrice;
          }
        }
        this.form.totalCostPrice = totalCostPrice;
        this.calculateCurrency();
      }
    },
    calculateProfitAndSales() {
      var profitPrice = 0;
      var salesPrice = 0;
      for (var item of this.form.chargedItemList) {
        var number = 0;
        if (item.ProfitPrice) {
          if (item.IsMandatoryItem == 1) {
            number = parseFloat(item.ProfitPrice);
          }
          if (this.form.isChargeUponDelivery || this.form.isCostReimbursement) {
            if (this.form.isChargeUponDelivery && item.IsMandatoryItem == 2) {
              number = parseFloat(item.ProfitPrice);
            }
            if (this.form.isCostReimbursement && item.IsMandatoryItem == 3) {
              number = parseFloat(item.ProfitPrice);
            }
          }
        }
        profitPrice = profitPrice + number;
      }
      //计算利润
      this.form.totalProfitPrice = profitPrice;
      this.form.totalProfitPrice = profitPrice.toFixed(2);
      //计算售价
      salesPrice = this.form.totalCostPrice + profitPrice;
      this.form.totalSalesPrice = salesPrice.toFixed(2);
      this.calculateCurrency();
    },
    calculateCurrency() {
      //计算货币汇率
      if (this.currencyList.length > 0) {
        for (var item of this.currencyList) {
          if (item.text == this.currency.text) {
            //显示用
            this.totalCostPrice = this.form.totalCostPrice * item.value;
            this.totalCostPrice = this.totalCostPrice.toFixed(2);
            this.totalProfitPrice = this.form.totalProfitPrice * item.value;
            this.totalProfitPrice = this.totalProfitPrice.toFixed(2);
            this.totalSalesPrice = this.form.totalSalesPrice * item.value;
            this.totalSalesPrice = this.totalSalesPrice.toFixed(2);
          }
        }
      }
    },
    showCalculate() {
      var messages = [];
      for (var list of this.calculationDetailsList) {
        for (var text of list) {
          messages.push(text);
        }
      }
      messages = messages.join("<br/><br/>");
      this.$commonMethod.customAlert2(
        {
          message: messages,
          showCancelButton: false,
          confirmButtonText: this.$t.alert.confirmButtonText,
        },
        () => {},
        () => {}
      );
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.voucherList[this.filesIndex].VoucherFile = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.quotationSupplierCreate {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  ::v-deep .customCheckBox {
    .van-cell__title {
      color: #646566 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .quotationSupplierCreate-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .quotationSupplierCreate-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;
      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        width: 50%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        .van-icon {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
    .multi-table-footer {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
      .primary-btn {
        border-radius: 5px;
        background: $-color-primary;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .fileList-dialog {
    top: 50% !important;
    .fileList-alert {
      overflow: scroll;
      height: 120vw;
      margin-top: 30px;
      margin-bottom: 30px;
      .fileList-table {
        .fileList-table-header {
          padding: 10px 15px;
          .fileList-table-btn {
            font-size: 20px;
            color: #000;
            width: 100%;
            display: inline-block;
            text-align: right;
            vertical-align: middle;
          }
        }
      }
      .fileList-list {
        .fileList-container {
          margin-top: 10px;
          font-size: 12px;
          color: #333;
          box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
          padding: 10px;
          .fileList-list-item {
            margin-bottom: 10px;
          }
          .fileList-list-item:last-child {
            margin-bottom: 0px !important;
          }
          .fileList-buttons {
            text-align: center;
            .primary-btn {
              border-radius: 5px;
              background: $-color-primary;
              border: none;
              .van-button__text {
                font-size: 14px !important;
              }
            }
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .tool-button {
      align-items: center;
    }
  }
}
</style>
